import { getSource, getSourceId, getTimestamp, getUpdate
// @ts-expect-error module not typed
} from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
// @ts-expect-error module not typed
import { isSystemUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isSystemUpdate';
// @ts-expect-error module not typed
import { getPipelineStage } from 'conversations-message-history/crm-object-lifecycle-update/operators/ticketUpdateMetadataGetters';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error module not typed
import { getDateString } from 'conversations-message-history/util/labelDateUtils';
import SystemMessage from '../system-message/SystemMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { TicketIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadCrmTicketUpdatedMessage = ({
  message,
  senders,
  userId,
  ungatedForThreadMessagesUIImprovements
}) => {
  const senderId = getSourceId(message);
  const senderType = getSource(message);
  const timestamp = getTimestamp(message);
  const momentTimestamp = I18n.moment(timestamp);
  const messageOptions = {
    dateString: getDateString(momentTimestamp),
    pipelineStage: /*#__PURE__*/_jsx("b", {
      children: getPipelineStage(getUpdate(message))
    })
  };
  if (senderId === userId) {
    return /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: timestamp,
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadUpdate.currentAgent",
        options: messageOptions
      }),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: '0',
        icon: TicketIcon,
        size: '500'
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  }
  if (isSystemUpdate(message)) {
    return /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: timestamp,
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadUpdate.system",
        options: messageOptions
      }),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: '0',
        icon: TicketIcon,
        size: '500'
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  }
  const asyncSender = findSender(senderId, senderType, senders);
  const isLoading = isSenderLoading(asyncSender);
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "200px"
    });
  }
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: timestamp,
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.threadUpdate.agent",
      options: Object.assign({
        agent: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FullSenderName, {
            sender: asyncSender && getData(asyncSender)
          })
        })
      }, messageOptions)
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: '0',
      icon: TicketIcon,
      size: '500'
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
ThreadCrmTicketUpdatedMessage.displayName = 'ThreadCrmTicketUpdatedMessage';
export default ThreadCrmTicketUpdatedMessage;